import { nanoid } from 'nanoid';
export default class MonthlyArc {
    constructor(displayName, name, amount, color) {
        this.id = nanoid();
        this.displayName = displayName;
        this.name = name;
        this.amount = amount;
        this.color = color;
    }
}
